var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardOverviewCrashrankinglistIcon = function SvgNewcsDashboardOverviewCrashrankinglistIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_overview_crashrankinglist_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M710 97h18v18h-18z",
    "data-name": "\\u77E9\\u5F62 2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_overview_crashrankinglist_icon_svg__a)",
    transform: "translate(-710 -97)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M721.5 98v16h-5V98Zm-1.5 1.5h-2v13h2Zm-5 6.5v8h-5v-8Zm-1.5 1.5h-2v5h2Zm14.5-5V114h-5v-11.5Zm-1.5 1.5h-2v8.5h2Z",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardOverviewCrashrankinglistIcon;